import {
  FETCH_OPEN_ORDERS,
  FETCH_OPEN_ORDERS_ERROR,
  FETCH_OPEN_ORDERS_SUCCESS,
  OpenOrdersActions,
} from '../../../types/actions/Exchanges/OpenOrders.actions';
import {IOpenOrders} from '../../../types/models/OpenOrders';

export interface OpenOrdersState {
  data: IOpenOrders | null;
  isLoading: boolean;
}

const initialState: OpenOrdersState = {
  isLoading: false,
  data: null,
};

export default (
  state = initialState,
  action: OpenOrdersActions,
): OpenOrdersState => {
  switch (action.type) {
    case FETCH_OPEN_ORDERS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_OPEN_ORDERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    }
    case FETCH_OPEN_ORDERS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
